export const calcDateDay = (value: string) => {
	const date = new Date(value);

	return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
};
